export const AI_GUIDE_SESSION_EVENT_START = "familysync-ai-guide-start";
export const AI_GUIDE_SESSION_EVENT_CLEAR = "familysync-ai-guide-clear";
export const AI_GUIDE_SESSION_EVENT_STATUS = "familysync-ai-guide-status";
export const AI_GUIDE_SESSION_EVENT_REQUEST_HIGHLIGHT = "familysync-ai-guide-request-highlight";
export const AI_GUIDE_SESSION_EVENT_COMPLETE_STEP = "familysync-ai-guide-complete-step";

export const AI_GUIDE_VIEW_LABELS = {
  kids: "Kids Board",
  parent: "Parent Hub",
  settings: "Settings",
  feedback: "Support Center"
};

export const AI_GUIDE_TARGET_DETAILS = {
  "nav-kids": {
    label: "Kids Board tab",
    title: "Open Kids Board",
    instruction: "In the app top navigation, tap Kids Board.",
    context: "This opens the board where kids view and submit chores.",
    view: "kids"
  },
  "nav-parent": {
    label: "Parent Hub tab",
    title: "Open Parent Hub",
    instruction: "In the app top navigation, tap Parent Hub.",
    context: "Parent Hub is where you assign, review, and manage chores.",
    view: "parent"
  },
  "nav-settings": {
    label: "Settings tab",
    title: "Open Settings",
    instruction: "In the app top navigation, tap Settings.",
    context: "Settings is where family options, kids management, and controls are configured.",
    view: "settings"
  },
  "settings-section-settings": {
    label: "App Settings section",
    title: "Open App Settings Section",
    instruction: "In Settings, open the App Settings section from the left menu.",
    context: "The Kids tab is inside App Settings.",
    view: "settings",
    settingsSection: "settings"
  },
  "settings-section-family": {
    label: "Family & Roles section",
    title: "Open Family & Roles Section",
    instruction: "In Settings, open Family & Roles from the left menu.",
    context: "Use this section to create and manage families.",
    view: "settings",
    settingsSection: "family"
  },
  "settings-section-integrations": {
    label: "Calendar Sync section",
    title: "Open Calendar Sync Section",
    instruction: "In Settings, open Calendar Sync from the left menu.",
    context: "Use this section to connect Google or Microsoft calendar sync.",
    view: "settings",
    settingsSection: "integrations"
  },
  "nav-feedback": {
    label: "Support tab",
    title: "Open Support Center",
    instruction: "In the app top navigation, tap Support.",
    context: "Support Center contains AI Help, Admin Help, and feedback threads.",
    view: "feedback"
  },
  "feedback-page": {
    label: "Support page",
    title: "Open Support Page",
    instruction: "Stay on Support Center.",
    context: "This is where AI Help and support threads are managed.",
    view: "feedback"
  },
  "parent-task-card": {
    label: "Assign Chores card",
    title: "Find Assign Chores",
    instruction: "In Parent Hub, locate the Assign Chores card.",
    context: "Use this card to create chores and send them to kids.",
    view: "parent"
  },
  "task-title-input": {
    label: "Task title field",
    title: "Enter Task Title",
    instruction: "In Parent Hub > Assign Chores, click Task Title and type the chore name.",
    context: "A clear title helps kids understand exactly what to do.",
    view: "parent"
  },
  "parent-approvals-card": {
    label: "Approvals card",
    title: "Open Approvals",
    instruction: "In Parent Hub, open the Approvals card and review pending submissions.",
    context: "Approve completed chores or request clarification.",
    view: "parent"
  },
  "parent-clarifications-card": {
    label: "Clarifications card",
    title: "Open Clarifications",
    instruction: "In Parent Hub, open Clarifications for questions and follow-ups.",
    context: "Clarifications are tracked separately from approvals.",
    view: "parent"
  },
  "settings-kids-tab": {
    label: "Kids settings tab",
    title: "Open Kids Tab",
    instruction: "In Settings -> App Settings, tap the Kids tab.",
    context: "Path: Settings -> App Settings -> Kids. This tab manages kid profiles, PINs, and access.",
    view: "settings",
    settingsTab: "kids"
  },
  "settings-add-kid": {
    label: "Add child controls",
    title: "Add a Kid",
    instruction: "In Settings -> Kids -> Add Child, type the child name and press Add Child.",
    context: "This creates the kid profile in the currently active family.",
    view: "settings",
    settingsTab: "kids"
  },
  "settings-add-kid-input": {
    label: "Child name field",
    title: "Enter Child Name",
    instruction: "In Settings -> Kids -> Add Child, type the child name in the input field.",
    context: "Use a clear first name so parent and kid views stay easy to read.",
    view: "settings",
    settingsTab: "kids"
  },
  "settings-add-kid-button": {
    label: "Add Child button",
    title: "Save New Child",
    instruction: "In Settings -> Kids -> Add Child, press the Add Child button.",
    context: "This creates the child account in your current family.",
    view: "settings",
    settingsTab: "kids"
  },
  "settings-add-family-input": {
    label: "New family name field",
    title: "Enter Family Name",
    instruction: "In Settings -> Family & Roles, type the new family name.",
    context: "Choose a clear family name so it is easy to select later.",
    view: "settings",
    settingsSection: "family"
  },
  "settings-add-family-button": {
    label: "Add Family button",
    title: "Create Family",
    instruction: "In Settings -> Family & Roles, press Add Family.",
    context: "This creates a new family and adds your account as parent.",
    view: "settings",
    settingsSection: "family"
  },
  "layout-toolbar": {
    label: "Layout toolbar",
    title: "Open Layout Toolbar",
    instruction: "Go to Parent Hub and locate the layout toolbar near the board controls.",
    context: "Layout controls let you adjust card size and arrangement.",
    view: "parent"
  },
  "card-controls": {
    label: "Card controls",
    title: "Adjust Card Controls",
    instruction: "In Parent Hub layout controls, adjust card size to your preferred width/height.",
    context: "Cards should scroll internally instead of stretching the page.",
    view: "parent"
  },
  "settings-home-setup": {
    label: "Home setup section",
    title: "Open Home Setup",
    instruction: "In Settings -> App Settings, open the Home Setup section.",
    context: "Home Setup controls key family onboarding options.",
    view: "settings"
  },
  "parent-calendar-card": {
    label: "Calendar card",
    title: "Open Calendar Card",
    instruction: "In Parent Hub, find the Calendar card.",
    context: "Use this card to add family calendar events.",
    view: "parent"
  },
  "calendar-event-title-input": {
    label: "Event title field",
    title: "Enter Event Title",
    instruction: "In Parent Hub -> Calendar, type the event title.",
    context: "Use a clear event name so kids and parents understand it quickly.",
    view: "parent"
  },
  "calendar-event-date-input": {
    label: "Event date field",
    title: "Set Event Date",
    instruction: "In Parent Hub -> Calendar, choose the event date.",
    context: "The event date is required before adding the event.",
    view: "parent"
  },
  "calendar-event-add-button": {
    label: "Add Event button",
    title: "Save Calendar Event",
    instruction: "In Parent Hub -> Calendar, press Add Event.",
    context: "This adds the event to your family calendar list.",
    view: "parent"
  }
};

export const getGuideTargetDetails = (targetId) => {
  const fallback = {
    label: String(targetId || "step"),
    title: "Complete This Step",
    instruction: `Use ${String(targetId || "the highlighted control")}.`,
    context: "Finish this step, then continue to the next one.",
    view: null,
    settingsTab: null
  };
  if (!targetId) return fallback;
  return {
    ...fallback,
    ...(AI_GUIDE_TARGET_DETAILS[targetId] || {})
  };
};
